import { BackendError } from '@genial/services';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React, { useCallback, useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';

import { useRecoilQuery } from '../../hooks/useRecoilQuery';
import { SignedInNavigationScreenNavigationProp } from '../../routes/types';
import { searchTermState } from '../../store/blockList/atom';
import { tradingListCustomerQuery } from '../../store/trading/selector';

import { ContainerDesktop } from './Desktop';
import { ContainerMobile } from './Mobile';
export const Trading = () => {
  const [searchTerm, setSearchTerm] = useRecoilState(searchTermState);
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const [updatedAt, setUpdatedAt] = useState(new Date());

  const {
    data: tradingList,
    error: customersLockListError,
    loading: customersLockListLoading,
    refresher,
  } = useRecoilQuery(tradingListCustomerQuery({ searchTerm }), {
    cachePolicy: 'no-cache',
  });

  useEffect(() => {
    if (tradingList?.data.length) {
      setUpdatedAt(new Date());
    }
  }, [tradingList]);

  const isMobile = useBreakpointValue({ base: true, sm: false });

  const [filtered, setFiltered] = useState(false);

  useEffect(() => {
    if (searchTerm.length > 0 && !filtered) {
      setFiltered(true);
    }
  }, [searchTerm, filtered]);

  const handleNavigate = ({
    currentIdAccount,
    currentAccountPNP,
    currentSinacorAccount,
    currentAccountBP,
  }) => {
    navigate('TradingDetails', {
      accountId: currentIdAccount,
      accountPNP: currentAccountPNP,
      sinacorAccount: currentSinacorAccount,
      accountBP: currentAccountBP,
    });
  };

  const handleClearSearchTerm = React.useCallback(() => {
    setSearchTerm('');
    setFiltered(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [renderedItems, setRenderedItems] = useState(10);

  const addMoreItemsQty = 10;

  const onLoadMore = () => {
    if (tradingList) {
      if (renderedItems < tradingList.data.length) {
        setRenderedItems(renderedItems + addMoreItemsQty);
      }
    }
  };

  const handleRefresh = useCallback(() => {
    refresher();
    setSearchTerm('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresher]);

  const responsiveContainer = useBreakpointValue({
    base: (
      <ContainerMobile
        renderedItems={renderedItems}
        handleNavigate={handleNavigate}
        isMobile={isMobile}
        searchTerm={searchTerm}
        onSetSearchTerm={setSearchTerm}
        onClearSearchTerm={handleClearSearchTerm}
        onLoadMore={onLoadMore}
        tradingList={tradingList?.data}
        tradingListLoading={customersLockListLoading}
        tradingListError={customersLockListError as unknown as BackendError}
        filtered={filtered}
        onRefresh={handleRefresh}
        updatedAt={updatedAt}
      />
    ),
    sm: (
      <ContainerDesktop
        renderedItems={renderedItems}
        handleNavigate={handleNavigate}
        isMobile={isMobile}
        searchTerm={searchTerm}
        onSetSearchTerm={setSearchTerm}
        onClearSearchTerm={handleClearSearchTerm}
        onLoadMore={onLoadMore}
        tradingList={tradingList?.data}
        tradingListLoading={customersLockListLoading}
        tradingListError={customersLockListError as unknown as BackendError}
        filtered={filtered}
        onRefresh={handleRefresh}
        updatedAt={updatedAt}
      />
    ),
  });

  return responsiveContainer;
};
